export interface Special {
  id: string;
  title: string;
  cover: string;
  summary: string;
  reason: string;
  movieIds: string[];
}

export const specials: Special[] = [
  {
    id: 'dark-mystery',
    title: '暗夜迷情：五部高分成人向悬疑片',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20male%20portrait%20collage%20style%20film%20key%20art%2C%20foggy%20night%20city%20and%20a%20lone%20silhouette%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=1200&height=675&seq=sexsp-01&orientation=landscape',
    summary:
      '当夜色成为最好的掩护，谎言与真相只隔一层薄雾。本专题精选五部气氛凝练、结构精巧的成人向悬疑作品，带你走进那些藏在暗处的故事。',
    reason:
      '这几部作品都不靠血腥取胜，而是把悬念建立在人物关系与心理博弈上。适合喜欢慢热、重氛围、愿意反复回味的观众，也是理解成人向叙事张力的入门片单。',
    movieIds: ['night-desire', 'silent-night', 'stranger-pillow', 'dark-undercurrent', 'misty-manor'],
  },
  {
    id: 'desire-city',
    title: '欲望都市：当情感剧遇上成人视角',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20city%20skyline%20at%20night%20seen%20through%20rain%20covered%20glass%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=1200&height=675&seq=sexsp-02&orientation=landscape',
    summary:
      '都市从不缺少故事，缺少的是愿意直视欲望的人。这个专题收录几部以情感与选择为核心的作品，探讨成年人在关系里的进退与代价。',
    reason:
      '它们把镜头对准关系本身，而非猎奇情节。人物有分寸、有犹豫，也有代价，读起来像成年人之间的坦诚对话。适合想找有共鸣、有讨论度的都市情感剧的观众。',
    movieIds: ['desire-district', 'red-lips', 'forbidden-edge', 'barcelona-love', 'last-dance'],
  },
  {
    id: 'neon-crime',
    title: '霓虹罪案：港日犯罪美学特辑',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20neon%20rain%20soaked%20alley%20at%20night%20with%20reflections%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=1200&height=675&seq=sexsp-03&orientation=landscape',
    summary:
      '雨夜、霓虹与霓虹下的抉择，是犯罪题材最迷人的底色。本专题汇集几部兼具视觉风格与人物厚度的犯罪作品。',
    reason:
      '这一片单兼顾了商业节奏与作者表达，既有紧张的行动场面，也保留了足够的人物留白。适合喜欢冷峻美学、又想看到人性挣扎的观众。',
    movieIds: ['neon-abyss', 'rose-and-gun', 'edge-city', 'crime-and-longing', 'paradise-lost-street'],
  },
];